import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Form from "./sidebar/Form";
import ClickOutside from "../../utils/clickOutSide";

function FloatingButton() {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const modalRef = useRef<HTMLDivElement | null>(null);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {isModalOpen && (
        <div
          className="modal show custom_modal"
          aria-labelledby="editModal"
          aria-hidden={!isModalOpen}
        >
          <ClickOutside isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} ref={modalRef} />
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" ref={modalRef}>
              <div className="modal-header">
                <h5 className="modal-title">Contact</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <Form />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="widget-menu-list">
        <ul className="widget-menu">
          <li className="widget-menu-item mb-2">
            <div
              className="widget-menu-link"
              onClick={() => setIsModalOpen(true)}
            >
              <i className="fa fa-address-card" aria-hidden="true"></i>
              <span>Contact</span>
            </div>
          </li>
          <li className="widget-menu-item mb-2">
            <div className="widget-menu-link">
              <i className="fas fa-phone"></i>
              <div className="d-grid">
                <span>
                  <a href="tel:+01149048335">011 49048335</a>
                </span>
                <span>
                  {" "}
                  <a href="tel:++917428599745">+91 7428599745</a>
                </span>
              </div>
            </div>
          </li>
          <li className="widget-menu-item">
            <div className="widget-menu-link">
              <span className="ng-star-inserted">
                <i className="fas fa-link" />
              </span>
              <b>Important Links</b>
            </div>
            <ul className="dropdown-menu-list ng-star-inserted">
              <li className="dropdown-menu-item ng-star-inserted">
                <Link to="/mecat" className="dropdown-menu-link">
                  MECAT
                </Link>
              </li>
              <li className="dropdown-menu-item ng-star-inserted">
                <Link to="/creative-warriors" className="dropdown-menu-link">
                  Creative Warriors
                </Link>
              </li>
              <li className="dropdown-menu-item ng-star-inserted">
                <Link to="/vidyadaan" className="dropdown-menu-link">
                  Vidyadaan
                </Link>
              </li>
              <li className="dropdown-menu-item ng-star-inserted">
                <Link to="/awsitc" className="dropdown-menu-link">
                  AWSITC
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
}

export default FloatingButton;
